
import Component from '../../../assets/scripts/modules/component'

export default class ScrollToTopComponent extends Component {
  async init () {
    this.button = this.element.querySelector('.button')

    if (!this.button) {
      return
    }

    this.button.addEventListener('click', event => this.clickHandler(event))
  }

  update () {
    //
  }

  destroy () {
    //
  }

  clickHandler (event) {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })

    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    function focusFirstElement () {
      document.querySelector('button, body [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').focus()
    }

    function handleScrollend () {
      focusFirstElement()
      window.removeEventListener('scrollend', handleScrollend)
    }

    if (document.documentElement.scrollTop <= 0) {
      focusFirstElement()
    } else {
      window.addEventListener('scrollend', handleScrollend)
    }
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.scroll-to-top')) {
    element.instance = element.instance || new ScrollToTopComponent(element)
  }
})
